'use client'

import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface FAQItem {
  question: string
  answer: string
}

interface VisaFAQProps {
  faqs?: FAQItem[]
}

export function VisaFAQ({ faqs = [] }: VisaFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  if (!faqs || faqs.length === 0) {
    return null
  }

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="pt-0 py-12 md:py-16 px-6 md:px-12">
      <div className="max-w-4xl mx-auto">
        {/* Subtle divider */}
        <div className="h-px bg-primary/15 mb-10 md:mb-14" />

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-gray-900 mb-8 md:mb-12 text-center">
          Frequently Asked <span className="italic text-brand-gold font-serif">Questions</span>
        </h2>

        <div className="divide-y divide-primary/20">
          {faqs.map((faq, index) => (
            <div key={index} className="py-6 md:py-8">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between text-left group"
                aria-expanded={openIndex === index}
              >
                <span className="text-base md:text-lg font-medium text-gray-900 pr-4 group-hover:text-brand-blue transition-colors">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-gray-600 shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>

              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  openIndex === index
                    ? 'grid-rows-[1fr] opacity-100 mt-4'
                    : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
